import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { startUndoable, crudUpdateMany } from 'ra-core';
import Button from '@material-ui/core/Button'

class BulkActionButton extends Component {
    // componentDidMount = () => {




    //     // this.props.onExit();

    // };
    handleAction = () => {
        const { basePath, startUndoable, resource, selectedIds, field, value } = this.props;
        startUndoable(
            crudUpdateMany(resource, selectedIds, { [field]: value }, basePath)
        );

    };
    render() {
        const { label } = this.props;
        return (<Button variant="contained" color="primary" onClick={ this.handleAction }>{ label }
        </Button>)
    }
}

BulkActionButton.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    // onExit: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
    selectedIds: PropTypes.arrayOf(PropTypes.any).isRequired,
    startUndoable: PropTypes.func.isRequired,
};

export default connect(undefined, { startUndoable })(BulkActionButton);
